import { Observable, Observer } from 'rxjs';

export abstract class LMWorker {

  protected abstract has(i: number): boolean
  protected abstract run(i: number): Observable<boolean>
  protected abstract get(i: number): any

  public start(): Observable<boolean> {
    return new Observable<boolean>(startCallback => {
      this._iterate(0, startCallback);
    });
  }

  private _iterate(i: number, startCallback: Observer<boolean>) {
    if (this.has(i)) {
      this.run(i).subscribe((continueOn: boolean) => {
        if (!continueOn) {
          startCallback.error(this.get(i));  // pass back the object that failed
          startCallback.complete();
        } else {
          i++;
          this._iterate(i, startCallback);
        }
      });
    } else {
      startCallback.next(true);
      startCallback.complete();
    }
  }
}
